export const wavFiles = {
  "Assorted-Hits": {
    "Kicks": [
      {
        "Loose-Kick": [
          "CYCdh_LooseKick-01.wav",
          "CYCdh_LooseKick-02.wav",
          "CYCdh_LooseKick-03.wav",
          "CYCdh_LooseKick-04.wav",
          "CYCdh_LooseKick-05.wav",
          "CYCdh_LooseKick-06.wav",
          "CYCdh_LooseKick-07.wav",
          "CYCdh_LooseKick-08.wav"
        ],
        "Acoustic": [
          "CYCdh_AcouKick-01.wav",
          "CYCdh_AcouKick-02.wav",
          "CYCdh_AcouKick-03.wav",
          "CYCdh_AcouKick-04.wav",
          "CYCdh_AcouKick-05.wav",
          "CYCdh_AcouKick-06.wav",
          "CYCdh_AcouKick-07.wav",
          "CYCdh_AcouKick-08.wav",
          "CYCdh_AcouKick-09.wav",
          "CYCdh_AcouKick-10.wav",
          "CYCdh_AcouKick-11.wav",
          "CYCdh_AcouKick-12.wav",
          "CYCdh_AcouKick-13.wav",
          "CYCdh_AcouKick-14.wav",
          "CYCdh_AcouKick-15.wav",
          "CYCdh_AcouKick-16.wav",
          "CYCdh_AcouKick-17.wav",
          "CYCdh_AcouKick-18.wav",
          "CYCdh_AcouKick-19.wav",
          "CYCdh_AcouKick-20.wav"
        ],
        "Kes-Kick": [
          "CYCdh_KesKick-01.wav",
          "CYCdh_KesKick-02.wav",
          "CYCdh_KesKick-03.wav",
          "CYCdh_KesKick-04.wav",
          "CYCdh_KesKick-05.wav",
          "CYCdh_KesKick-06.wav",
          "CYCdh_KesKick-07.wav",
          "CYCdh_KesKick-08.wav"
        ]
      }
    ],
    "Cymbals": [
      {
        "Trash-Crashes": [
          "CYCdh_TrashA-01.wav",
          "CYCdh_TrashA-02.wav",
          "CYCdh_TrashA-03.wav",
          "CYCdh_TrashA-04.wav",
          "CYCdh_TrashA-05.wav",
          "CYCdh_TrashA-06.wav",
          "CYCdh_TrashA-07.wav",
          "CYCdh_TrashA-08.wav",
          "CYCdh_TrashA-09.wav",
          "CYCdh_TrashB-01.wav",
          "CYCdh_TrashB-02.wav",
          "CYCdh_TrashB-03.wav",
          "CYCdh_TrashC-01.wav",
          "CYCdh_TrashC-02.wav",
          "CYCdh_TrashC-03.wav",
          "CYCdh_TrashC-04.wav",
          "CYCdh_TrashD-01.wav",
          "CYCdh_TrashD-02.wav",
          "CYCdh_TrashE-01.wav",
          "CYCdh_TrashE-02.wav",
          "CYCdh_TrashE-03.wav",
          "CYCdh_TrashE-04.wav",
          "CYCdh_TrashE-05.wav",
          "CYCdh_TrashF-01.wav",
          "CYCdh_TrashF-02.wav",
          "CYCdh_TrashF-03.wav",
          "CYCdh_TrashF-04.wav"
        ]
      },
      "CYCdh_Crash-01.wav",
      "CYCdh_Crash-02.wav",
      "CYCdh_Crash-03.wav",
      "CYCdh_MultiCrash-01.wav",
      "CYCdh_MultiCrash-02.wav",
      "CYCdh_MultiCrash-03.wav",
      "CYCdh_MultiCrashHi-01.wav",
      "CYCdh_MultiCrashHi-02.wav",
      "CYCdh_MultiCrashHi-03.wav",
      "CYCdh_MultiCrashLo-01.wav",
      "CYCdh_MultiCrashLo-02.wav",
      "CYCdh_MultiCrashLo-03.wav"
    ],
    "Hi-Hats": [
      {
        "Acoustic": [
          "Acoustic-Hat-01.wav",
          "Acoustic-Hat-02.wav",
          "Acoustic-Hat-03.wav",
          "Acoustic-Hat-04.wav",
          "Acoustic-Hat-05.wav",
          "Acoustic-Hat-06.wav"
        ],
        "Sabian-B8": [
          "CYCdh_Sab_ClHat-01.wav",
          "CYCdh_Sab_ClHat-02.wav",
          "CYCdh_Sab_ClHat-03.wav",
          "CYCdh_Sab_ClHat-04.wav",
          "CYCdh_Sab_ClHat-05.wav",
          "CYCdh_Sab_ClHat-06.wav",
          "CYCdh_Sab_ClHat-07.wav",
          "CYCdh_Sab_ClHat-08.wav",
          "CYCdh_Sab_ClHat-09.wav",
          "CYCdh_Sab_ClHat-10.wav",
          "CYCdh_Sab_ClHat-11.wav",
          "CYCdh_Sab_ClHat-12.wav",
          "CYCdh_Sab_ClHat-13.wav",
          "CYCdh_Sab_ClHat-14.wav",
          "CYCdh_Sab_HfHat-01.wav",
          "CYCdh_Sab_HfHat-02.wav",
          "CYCdh_Sab_HfHat-03.wav",
          "CYCdh_Sab_HfHat-04.wav",
          "CYCdh_Sab_OpHat-01.wav",
          "CYCdh_Sab_OpHat-02.wav",
          "CYCdh_Sab_OpHat-03.wav",
          "CYCdh_Sab_OpHat-04.wav",
          "CYCdh_Sab_OpHat-05.wav",
          "CYCdh_Sab_OpHat-06.wav",
          "CYCdh_Sab_OpHat-07.wav",
          "CYCdh_Sab_OpHat-08.wav",
          "CYCdh_Sab_OpHat-09.wav",
          "CYCdh_Sab_PdHat-01.wav",
          "CYCdh_Sab_PdHat-02.wav"
        ],
        "Zildjian-K-Hats": [
          "KHats-Clsd-01.wav",
          "KHats-Clsd-02.wav",
          "KHats-Clsd-03.wav",
          "KHats-Clsd-04.wav",
          "KHats-Clsd-05.wav",
          "KHats-Clsd-06.wav",
          "KHats-Clsd-07.wav",
          "KHats-Clsd-08.wav",
          "KHats-Clsd-09.wav",
          "KHats-Clsd-10.wav",
          "KHats-Clsd-11.wav",
          "KHats-HlfOp-01.wav",
          "KHats-HlfOp-02.wav",
          "KHats-HlfOp-03.wav",
          "KHats-Open-01.wav",
          "KHats-Open-02.wav",
          "KHats-Open-03.wav",
          "KHats-Open-04.wav",
          "KHats-Open-05.wav",
          "KHats-Open-06.wav",
          "KHats-Open-07.wav",
          "KHats-Open-08.wav",
          "KHats-Open-09.wav",
          "KHats-Pdl-01.wav",
          "KHats-Pdl-02.wav",
          "KHats-Pdl-03.wav",
          "KHats-Pdl-04.wav"
        ]
      }
    ],
    "Snares": [
      {
        "Acoustic": [
          "Acoustic-Snare-01.wav",
          "Acoustic-Snare-02.wav",
          "Acoustic-Snare-03.wav",
          "Acoustic-Snare-04.wav"
        ],
        "Ludwig-A": [
          "CYCdh_LudFlamA-01.wav",
          "CYCdh_LudFlamA-02.wav",
          "CYCdh_LudFlamA-03.wav",
          "CYCdh_LudFlamA-04.wav",
          "CYCdh_LudFlamA-05.wav",
          "CYCdh_LudRimA-01.wav",
          "CYCdh_LudRimA-02.wav",
          "CYCdh_LudRimA-03.wav",
          "CYCdh_LudRimA-04.wav",
          "CYCdh_LudRimA-05.wav",
          "CYCdh_LudRimA-06.wav",
          "CYCdh_LudRimA-07.wav",
          "CYCdh_LudSdStA-01.wav",
          "CYCdh_LudSdStA-02.wav",
          "CYCdh_LudSdStA-03.wav",
          "CYCdh_LudSdStA-04.wav",
          "CYCdh_LudSdStA-05.wav",
          "CYCdh_LudSdStA-06.wav",
          "CYCdh_LudSdStA-07.wav",
          "CYCdh_LudSnrA-01.wav",
          "CYCdh_LudSnrA-02.wav",
          "CYCdh_LudSnrA-03.wav",
          "CYCdh_LudSnrA-04.wav",
          "CYCdh_LudSnrA-05.wav",
          "CYCdh_LudSnrOffA-01.wav",
          "CYCdh_LudSnrOffA-02.wav",
          "CYCdh_LudSnrOffA-03.wav",
          "CYCdh_LudSnrOffA-04.wav",
          "CYCdh_LudSnrOffA-05.wav",
          "CYCdh_LudSnrOffA-06.wav",
          "CYCdh_LudSnrOffA-07.wav",
          "CYCdh_LudSnrOffA-08.wav"
        ],
        "Ludwig-B": [
          "CYCdh_LudFlamB-01.wav",
          "CYCdh_LudFlamB-02.wav",
          "CYCdh_LudFlamB-03.wav",
          "CYCdh_LudFlamB-04.wav",
          "CYCdh_LudFlamB-05.wav",
          "CYCdh_LudRimB-01.wav",
          "CYCdh_LudRimB-02.wav",
          "CYCdh_LudRimB-03.wav",
          "CYCdh_LudRimB-04.wav",
          "CYCdh_LudRimB-05.wav",
          "CYCdh_LudRimB-06.wav",
          "CYCdh_LudRimB-07.wav",
          "CYCdh_LudSdStB-01.wav",
          "CYCdh_LudSdStB-02.wav",
          "CYCdh_LudSdStB-03.wav",
          "CYCdh_LudSdStB-04.wav",
          "CYCdh_LudSdStB-05.wav",
          "CYCdh_LudSdStB-06.wav",
          "CYCdh_LudSdStB-07.wav",
          "CYCdh_LudSnrB-01.wav",
          "CYCdh_LudSnrB-02.wav",
          "CYCdh_LudSnrB-03.wav",
          "CYCdh_LudSnrB-04.wav",
          "CYCdh_LudSnrB-05.wav",
          "CYCdh_LudSnrOffB-01.wav",
          "CYCdh_LudSnrOffB-02.wav",
          "CYCdh_LudSnrOffB-03.wav",
          "CYCdh_LudSnrOffB-04.wav",
          "CYCdh_LudSnrOffB-05.wav",
          "CYCdh_LudSnrOffB-06.wav",
          "CYCdh_LudSnrOffB-07.wav",
          "CYCdh_LudSnrOffB-08.wav"
        ],
        "Ludwig-C": [
          "CYCdh_LudFlamC-01.wav",
          "CYCdh_LudFlamC-02.wav",
          "CYCdh_LudFlamC-03.wav",
          "CYCdh_LudFlamC-04.wav",
          "CYCdh_LudFlamC-05.wav",
          "CYCdh_LudRimC-01.wav",
          "CYCdh_LudRimC-02.wav",
          "CYCdh_LudRimC-03.wav",
          "CYCdh_LudRimC-04.wav",
          "CYCdh_LudRimC-05.wav",
          "CYCdh_LudRimC-06.wav",
          "CYCdh_LudRimC-07.wav",
          "CYCdh_LudSdStC-01.wav",
          "CYCdh_LudSdStC-02.wav",
          "CYCdh_LudSdStC-03.wav",
          "CYCdh_LudSdStC-04.wav",
          "CYCdh_LudSdStC-05.wav",
          "CYCdh_LudSdStC-06.wav",
          "CYCdh_LudSdStC-07.wav",
          "CYCdh_LudSnrC-01.wav",
          "CYCdh_LudSnrC-02.wav",
          "CYCdh_LudSnrC-03.wav",
          "CYCdh_LudSnrC-04.wav",
          "CYCdh_LudSnrC-05.wav",
          "CYCdh_LudSnrOffC-01.wav",
          "CYCdh_LudSnrOffC-02.wav",
          "CYCdh_LudSnrOffC-03.wav",
          "CYCdh_LudSnrOffC-04.wav",
          "CYCdh_LudSnrOffC-05.wav",
          "CYCdh_LudSnrOffC-06.wav",
          "CYCdh_LudSnrOffC-07.wav",
          "CYCdh_LudSnrOffC-08.wav"
        ],
        "Piccolo-Sidestick": [
          "PearlPiccolo-Side-SnrOff-01.wav",
          "PearlPiccolo-Side-SnrOff-02.wav",
          "PearlPiccolo-Side-SnrOff-03.wav",
          "PearlPiccolo-Side-SnrOff-04.wav",
          "PearlPiccolo-Side-SnrOff-05.wav",
          "PearlPiccolo-Side-SnrOn-01.wav",
          "PearlPiccolo-Side-SnrOn-02.wav",
          "PearlPiccolo-Side-SnrOn-03.wav",
          "PearlPiccolo-Side-SnrOn-04.wav",
          "PearlPiccolo-Side-SnrOn-05.wav",
          "PearlPiccolo-Side-SnrOn-06.wav",
          "PearlPiccolo-Side-SnrOn-07.wav",
          "PearlPiccolo-Side-SnrOn-08.wav",
          "PearlPiccolo-Side-SnrOn-09.wav"
        ],
        "Sonor-Force-3000": [
          "CYCdh_SonFlam-01.wav",
          "CYCdh_SonFlam-02.wav",
          "CYCdh_SonFlam-03.wav",
          "CYCdh_SonRim-01.wav",
          "CYCdh_SonRim-02.wav",
          "CYCdh_SonRim-03.wav",
          "CYCdh_SonRim-04.wav",
          "CYCdh_SonRim-05.wav",
          "CYCdh_SonRim-06.wav",
          "CYCdh_SonRim-07.wav",
          "CYCdh_SonRim-08.wav",
          "CYCdh_SonRim-09.wav",
          "CYCdh_SonRim-10.wav",
          "CYCdh_SonSdSt-01.wav",
          "CYCdh_SonSdSt-02.wav",
          "CYCdh_SonSdSt-03.wav",
          "CYCdh_SonSdSt-04.wav",
          "CYCdh_SonSdSt-05.wav",
          "CYCdh_SonSdSt-06.wav",
          "CYCdh_SonSdSt-07.wav",
          "CYCdh_SonSnr-01.wav",
          "CYCdh_SonSnr-02.wav",
          "CYCdh_SonSnr-03.wav",
          "CYCdh_SonSnr-04.wav",
          "CYCdh_SonSnr-05.wav",
          "CYCdh_SonSnr-06.wav",
          "CYCdh_SonSnrOff-01.wav",
          "CYCdh_SonSnrOff-02.wav",
          "CYCdh_SonSnrOff-03.wav",
          "CYCdh_SonSnrOff-04.wav",
          "CYCdh_SonSnrOff-05.wav",
          "CYCdh_SonSnrOff-06.wav",
          "CYCdh_SonUpsd-01.wav",
          "CYCdh_SonUpsd-02.wav",
          "CYCdh_SonUpsd-03.wav",
          "CYCdh_SonUpsd-04.wav",
          "CYCdh_SonUpsd-05.wav",
          "CYCdh_SonUpsd-06.wav",
          "CYCdh_SonUpsd-07.wav",
          "CYCdh_SonUpsd-08.wav"
        ],
        "Tama-Wood": [
          "CYCdh_TamFlam-01.wav",
          "CYCdh_TamFlam-02.wav",
          "CYCdh_TamFlam-03.wav",
          "CYCdh_TamRim-01.wav",
          "CYCdh_TamRim-02.wav",
          "CYCdh_TamRim-03.wav",
          "CYCdh_TamRim-04.wav",
          "CYCdh_TamRim-05.wav",
          "CYCdh_TamRim-06.wav",
          "CYCdh_TamRim-07.wav",
          "CYCdh_TamRim-08.wav",
          "CYCdh_TamRimTgt-01.wav",
          "CYCdh_TamRimTgt-02.wav",
          "CYCdh_TamRimTgt-03.wav",
          "CYCdh_TamRimTgt-04.wav",
          "CYCdh_TamRimTgt-05.wav",
          "CYCdh_TamSdSt-01.wav",
          "CYCdh_TamSdSt-02.wav",
          "CYCdh_TamSdSt-03.wav",
          "CYCdh_TamSdSt-04.wav",
          "CYCdh_TamSdSt-05.wav",
          "CYCdh_TamSdSt-06.wav",
          "CYCdh_TamSdSt-07.wav",
          "CYCdh_TamSdSt-08.wav",
          "CYCdh_TamSnr-01.wav",
          "CYCdh_TamSnr-02.wav",
          "CYCdh_TamSnr-03.wav",
          "CYCdh_TamSnr-04.wav",
          "CYCdh_TamSnr-05.wav",
          "CYCdh_TamSnr-06.wav",
          "CYCdh_TamSnr-07.wav",
          "CYCdh_TamSnr-08.wav",
          "CYCdh_TamSnrEd-01.wav",
          "CYCdh_TamSnrEd-02.wav",
          "CYCdh_TamSnrEd-03.wav",
          "CYCdh_TamSnrEd-04.wav",
          "CYCdh_TamSnrEd-05.wav",
          "CYCdh_TamSnrEd-06.wav",
          "CYCdh_TamSnrEd-07.wav",
          "CYCdh_TamSnrEd-08.wav",
          "CYCdh_TamSnrTgt-01.wav",
          "CYCdh_TamSnrTgt-02.wav",
          "CYCdh_TamSnrTgt-03.wav",
          "CYCdh_TamSnrTgt-04.wav",
          "CYCdh_TamSnrTgt-05.wav",
          "CYCdh_TamSnrTgt-06.wav",
          "CYCdh_TamSnrTgt-07.wav",
          "CYCdh_TamUpsd-01.wav",
          "CYCdh_TamUpsd-02.wav",
          "CYCdh_TamUpsd-03.wav",
          "CYCdh_TamUpsd-04.wav",
          "CYCdh_TamUpsd-05.wav",
          "CYCdh_TamUpsd-06.wav",
          "CYCdh_TamUpsd-07.wav",
          "CYCdh_TamUpsd-08.wav",
          "CYCdh_TamUpsd-09.wav"
        ],
        "Wooden-Piccolo": [
          "CYCdh_PiccoloA-01.wav",
          "CYCdh_PiccoloA-02.wav",
          "CYCdh_PiccoloA-03.wav",
          "CYCdh_PiccoloA-04.wav",
          "CYCdh_PiccoloB-01.wav",
          "CYCdh_PiccoloB-02.wav",
          "CYCdh_PiccoloB-03.wav",
          "CYCdh_PiccoloB-04.wav",
          "CYCdh_PiccoloC-01.wav",
          "CYCdh_PiccoloC-02.wav",
          "CYCdh_PiccoloC-03.wav",
          "CYCdh_PiccoloC-04.wav",
          "CYCdh_PiccoloD-01.wav",
          "CYCdh_PiccoloD-02.wav",
          "CYCdh_PiccoloD-03.wav",
          "CYCdh_PiccoloD-04.wav",
          "CYCdh_PiccoloE-01.wav",
          "CYCdh_PiccoloE-02.wav",
          "CYCdh_PiccoloE-03.wav",
          "CYCdh_PiccoloE-04.wav"
        ]
      }
    ]
  },
  "Drum-Kits": {
    "Kit-10-Vinyl": [
      "CYCdh_VinylK3-ClHat01.wav",
      "CYCdh_VinylK3-ClHat02.wav",
      "CYCdh_VinylK3-Kick01.wav",
      "CYCdh_VinylK3-Kick02.wav",
      "CYCdh_VinylK3-Kick03.wav",
      "CYCdh_VinylK3-Kick04.wav",
      "CYCdh_VinylK3-OpHat.wav",
      "CYCdh_VinylK3-Perc01.wav",
      "CYCdh_VinylK3-Perc02.wav",
      "CYCdh_VinylK3-Perc03.wav",
      "CYCdh_VinylK3-Perc04.wav",
      "CYCdh_VinylK3-Snr01.wav",
      "CYCdh_VinylK3-Snr02.wav"
    ],
    "Kit-11-Vinyl": [
      "CYCdh_VinylK4-China.wav",
      "CYCdh_VinylK4-ClHat01.wav",
      "CYCdh_VinylK4-ClHat02.wav",
      "CYCdh_VinylK4-ClHat03.wav",
      "CYCdh_VinylK4-ClHat04.wav",
      "CYCdh_VinylK4-ClHat05.wav",
      "CYCdh_VinylK4-Crash01.wav",
      "CYCdh_VinylK4-Crash02.wav",
      "CYCdh_VinylK4-Kick01.wav",
      "CYCdh_VinylK4-Kick02.wav",
      "CYCdh_VinylK4-OpHat01.wav",
      "CYCdh_VinylK4-OpHat02.wav",
      "CYCdh_VinylK4-Ride01.wav",
      "CYCdh_VinylK4-Ride02.wav",
      "CYCdh_VinylK4-Ride03.wav",
      "CYCdh_VinylK4-Ride04.wav",
      "CYCdh_VinylK4-Snr01.wav",
      "CYCdh_VinylK4-Snr02.wav",
      "CYCdh_VinylK4-Snr03.wav",
      "CYCdh_VinylK4-Snr04.wav",
      "CYCdh_VinylK4-Snr05.wav",
      "CYCdh_VinylK4-Snr06.wav",
      "CYCdh_VinylK4-Tom01.wav",
      "CYCdh_VinylK4-Tom02.wav",
      "CYCdh_VinylK4-Tom03.wav"
    ],
    "Kit-12-Vinyl": [
      "CYCdh_VinylK5-ClHat01.wav",
      "CYCdh_VinylK5-ClHat02.wav",
      "CYCdh_VinylK5-ClHat03.wav",
      "CYCdh_VinylK5-Kick01.wav",
      "CYCdh_VinylK5-Kick02.wav",
      "CYCdh_VinylK5-OpHat.wav",
      "CYCdh_VinylK5-Snr01.wav",
      "CYCdh_VinylK5-Snr02.wav",
      "CYCdh_VinylK5-Snr03.wav",
      "CYCdh_VinylK5-Snr04.wav",
      "CYCdh_VinylK5-Tom01.wav",
      "CYCdh_VinylK5-Tom02.wav",
      "CYCdh_VinylK5-Tom03.wav"
    ],
    "Kit-13-Acoustic": [
      "CYCdh_K4-4OpHat03.wav",
      "CYCdh_K4-ClHat01.wav",
      "CYCdh_K4-ClHat02.wav",
      "CYCdh_K4-ClHat03.wav",
      "CYCdh_K4-Kick01.wav",
      "CYCdh_K4-Kick02.wav",
      "CYCdh_K4-Kick03.wav",
      "CYCdh_K4-Kick04.wav",
      "CYCdh_K4-Kick05.wav",
      "CYCdh_K4-OpHat01.wav",
      "CYCdh_K4-OpHat02.wav",
      "CYCdh_K4-Snr01.wav",
      "CYCdh_K4-Snr02.wav",
      "CYCdh_K4-Snr03.wav",
      "CYCdh_K4-Snr04.wav",
      "CYCdh_K4-Snr05.wav",
      "CYCdh_K4-Snr06.wav",
      "CYCdh_K4-Snr07.wav",
      "CYCdh_K4-Snr08.wav",
      "CYCdh_K4-Snr09.wav",
      "CYCdh_K4-Snr10.wav",
      "CYCdh_K4-Snr11.wav",
      "CYCdh_K4-Trash01.wav",
      "CYCdh_K4-Trash02.wav",
      "CYCdh_K4-Trash03.wav",
      "CYCdh_K4-Trash04.wav",
      "CYCdh_K4-Trash05.wav",
      "CYCdh_K4-Trash06.wav",
      "CYCdh_K4-Trash07.wav",
      "CYCdh_K4-Trash08.wav",
      "CYCdh_K4-Trash09.wav",
      "CYCdh_K4-Trash10.wav"
    ],
    "Kit-14-Acoustic": [
      "CYCdh_K5-ClHat01.wav",
      "CYCdh_K5-ClHat02.wav",
      "CYCdh_K5-ClHat03.wav",
      "CYCdh_K5-Kick01.wav",
      "CYCdh_K5-Kick02.wav",
      "CYCdh_K5-Kick93.wav",
      "CYCdh_K5-OpHat01.wav",
      "CYCdh_K5-OpHat02.wav",
      "CYCdh_K5-PdHat.wav",
      "CYCdh_K5-Rim01.wav",
      "CYCdh_K5-Rim02.wav",
      "CYCdh_K5-Rim03.wav",
      "CYCdh_K5-SdSt01.wav",
      "CYCdh_K5-SdSt02.wav",
      "CYCdh_K5-SdSt03.wav",
      "CYCdh_K5-Snr01.wav",
      "CYCdh_K5-Snr02.wav",
      "CYCdh_K5-Snr03.wav",
      "CYCdh_K5-Snr04.wav",
      "CYCdh_K5-Tom01a.wav",
      "CYCdh_K5-Tom01b.wav",
      "CYCdh_K5-Tom01c.wav",
      "CYCdh_K5-Tom02a.wav",
      "CYCdh_K5-Tom02b.wav",
      "CYCdh_K5-Tom02c.wav",
      "CYCdh_K5-Tom03a.wav",
      "CYCdh_K5-Tom03b.wav",
      "CYCdh_K5-Tom03c.wav"
    ],
    "Kit-15-Electro": [
      "CYCdh_ElecK05-Clap01.wav",
      "CYCdh_ElecK05-Clap02.wav",
      "CYCdh_ElecK05-ClHat01.wav",
      "CYCdh_ElecK05-ClHat02.wav",
      "CYCdh_ElecK05-ClHat03.wav",
      "CYCdh_ElecK05-ClHat04.wav",
      "CYCdh_ElecK05-Kick01.wav",
      "CYCdh_ElecK05-Kick02.wav",
      "CYCdh_ElecK05-OpHat01.wav",
      "CYCdh_ElecK05-OpHat02.wav",
      "CYCdh_ElecK05-Snr01.wav",
      "CYCdh_ElecK05-Snr02.wav",
      "CYCdh_ElecK05-Snr03.wav",
      "CYCdh_ElecK05-Snr04.wav"
    ],
    "Kit-16-Electro": [
      "CYCdh_ElecK06-Clap01.wav",
      "CYCdh_ElecK06-Clap02.wav",
      "CYCdh_ElecK06-Clap03.wav",
      "CYCdh_ElecK06-ClHat01.wav",
      "CYCdh_ElecK06-ClHat02.wav",
      "CYCdh_ElecK06-Kick01.wav",
      "CYCdh_ElecK06-Kick02.wav",
      "CYCdh_ElecK06-OpHat.wav",
      "CYCdh_ElecK06-Snr01.wav",
      "CYCdh_ElecK06-Snr02.wav",
      "CYCdh_ElecK06-Snr03.wav"
    ],
    "Kit-17-Electro": [
      "CYCdh_ElecK07-ClHat01.wav",
      "CYCdh_ElecK07-ClHat02.wav",
      "CYCdh_ElecK07-Kick01.wav",
      "CYCdh_ElecK07-Kick02.wav",
      "CYCdh_ElecK07-OpHat.wav",
      "CYCdh_ElecK07-Snr01.wav",
      "CYCdh_ElecK07-Snr02.wav",
      "CYCdh_ElecK07-Snr03.wav"
    ],
    "Kit-18-Acoustic": [
      "CYCdh_K6-ClHat.wav",
      "CYCdh_K6-Kick01.wav",
      "CYCdh_K6-OpHat01.wav",
      "CYCdh_K6-OpHat02.wav",
      "CYCdh_K6-Snr01.wav",
      "CYCdh_K6-Snr02.wav",
      "CYCdh_K6-Snr03.wav",
      "CYCdh_K6-Snr04.wav",
      "CYCdh_K6-SnrBuzz.wav"
    ],
    "Kit-1-Acoustic-close": [
      "CYCdh_K1close_ClHat-01.wav",
      "CYCdh_K1close_ClHat-02.wav",
      "CYCdh_K1close_ClHat-03.wav",
      "CYCdh_K1close_ClHat-04.wav",
      "CYCdh_K1close_ClHat-05.wav",
      "CYCdh_K1close_ClHat-06.wav",
      "CYCdh_K1close_ClHat-07.wav",
      "CYCdh_K1close_ClHat-08.wav",
      "CYCdh_K1close_ClHat-09.wav",
      "CYCdh_K1close_Flam-01.wav",
      "CYCdh_K1close_Flam-02.wav",
      "CYCdh_K1close_Flam-03.wav",
      "CYCdh_K1close_Flam-04.wav",
      "CYCdh_K1close_Flam-05.wav",
      "CYCdh_K1close_Kick-01.wav",
      "CYCdh_K1close_Kick-02.wav",
      "CYCdh_K1close_Kick-03.wav",
      "CYCdh_K1close_Kick-04.wav",
      "CYCdh_K1close_Kick-05.wav",
      "CYCdh_K1close_Kick-06.wav",
      "CYCdh_K1close_Kick-07.wav",
      "CYCdh_K1close_Kick-08.wav",
      "CYCdh_K1close_OpHat-01.wav",
      "CYCdh_K1close_OpHat-02.wav",
      "CYCdh_K1close_OpHat-03.wav",
      "CYCdh_K1close_OpHat-04.wav",
      "CYCdh_K1close_OpHat-05.wav",
      "CYCdh_K1close_OpHat-06.wav",
      "CYCdh_K1close_OpHat-07.wav",
      "CYCdh_K1close_PdHat-01.wav",
      "CYCdh_K1close_PdHat-02.wav",
      "CYCdh_K1close_PdHat-03.wav",
      "CYCdh_K1close_PdHat-04.wav",
      "CYCdh_K1close_Rim-01.wav",
      "CYCdh_K1close_Rim-02.wav",
      "CYCdh_K1close_Rim-03.wav",
      "CYCdh_K1close_Rim-04.wav",
      "CYCdh_K1close_Rim-05.wav",
      "CYCdh_K1close_Rim-06.wav",
      "CYCdh_K1close_Rim-07.wav",
      "CYCdh_K1close_SdSt-01.wav",
      "CYCdh_K1close_SdSt-02.wav",
      "CYCdh_K1close_SdSt-03.wav",
      "CYCdh_K1close_SdSt-04.wav",
      "CYCdh_K1close_SdSt-05.wav",
      "CYCdh_K1close_SdSt-06.wav",
      "CYCdh_K1close_SdSt-07.wav",
      "CYCdh_K1close_Snr-01.wav",
      "CYCdh_K1close_Snr-02.wav",
      "CYCdh_K1close_Snr-03.wav",
      "CYCdh_K1close_Snr-04.wav",
      "CYCdh_K1close_Snr-05.wav",
      "CYCdh_K1close_SnrOff-01.wav",
      "CYCdh_K1close_SnrOff-02.wav",
      "CYCdh_K1close_SnrOff-03.wav",
      "CYCdh_K1close_SnrOff-04.wav",
      "CYCdh_K1close_SnrOff-05.wav",
      "CYCdh_K1close_SnrOff-06.wav",
      "CYCdh_K1close_SnrOff-07.wav",
      "CYCdh_K1close_SnrOff-08.wav"
    ],
    "Kit-2-Acoustic-room": [
      "CYCdh_K2room_ClHat-01.wav",
      "CYCdh_K2room_ClHat-02.wav",
      "CYCdh_K2room_ClHat-03.wav",
      "CYCdh_K2room_ClHat-04.wav",
      "CYCdh_K2room_ClHat-05.wav",
      "CYCdh_K2room_ClHat-06.wav",
      "CYCdh_K2room_ClHat-07.wav",
      "CYCdh_K2room_ClHat-08.wav",
      "CYCdh_K2room_ClHat-09.wav",
      "CYCdh_K2room_Flam-01.wav",
      "CYCdh_K2room_Flam-02.wav",
      "CYCdh_K2room_Flam-03.wav",
      "CYCdh_K2room_Flam-04.wav",
      "CYCdh_K2room_Flam-05.wav",
      "CYCdh_K2room_Kick-01.wav",
      "CYCdh_K2room_Kick-02.wav",
      "CYCdh_K2room_Kick-03.wav",
      "CYCdh_K2room_Kick-04.wav",
      "CYCdh_K2room_Kick-05.wav",
      "CYCdh_K2room_Kick-06.wav",
      "CYCdh_K2room_Kick-07.wav",
      "CYCdh_K2room_Kick-08.wav",
      "CYCdh_K2room_OpHat-01.wav",
      "CYCdh_K2room_OpHat-02.wav",
      "CYCdh_K2room_OpHat-03.wav",
      "CYCdh_K2room_OpHat-04.wav",
      "CYCdh_K2room_OpHat-05.wav",
      "CYCdh_K2room_OpHat-06.wav",
      "CYCdh_K2room_OpHat-07.wav",
      "CYCdh_K2room_PdHat-01.wav",
      "CYCdh_K2room_PdHat-02.wav",
      "CYCdh_K2room_PdHat-03.wav",
      "CYCdh_K2room_PdHat-04.wav",
      "CYCdh_K2room_Rim-01.wav",
      "CYCdh_K2room_Rim-02.wav",
      "CYCdh_K2room_Rim-03.wav",
      "CYCdh_K2room_Rim-04.wav",
      "CYCdh_K2room_Rim-05.wav",
      "CYCdh_K2room_Rim-06.wav",
      "CYCdh_K2room_Rim-07.wav",
      "CYCdh_K2room_SdSt-01.wav",
      "CYCdh_K2room_SdSt-02.wav",
      "CYCdh_K2room_SdSt-03.wav",
      "CYCdh_K2room_SdSt-04.wav",
      "CYCdh_K2room_SdSt-05.wav",
      "CYCdh_K2room_SdSt-06.wav",
      "CYCdh_K2room_SdSt-07.wav",
      "CYCdh_K2room_Snr-01.wav",
      "CYCdh_K2room_Snr-02.wav",
      "CYCdh_K2room_Snr-03.wav",
      "CYCdh_K2room_Snr-04.wav",
      "CYCdh_K2room_Snr-05.wav",
      "CYCdh_K2room_SnrOff-01.wav",
      "CYCdh_K2room_SnrOff-02.wav",
      "CYCdh_K2room_SnrOff-03.wav",
      "CYCdh_K2room_SnrOff-04.wav",
      "CYCdh_K2room_SnrOff-05.wav",
      "CYCdh_K2room_SnrOff-06.wav",
      "CYCdh_K2room_SnrOff-07.wav",
      "CYCdh_K2room_SnrOff-08.wav"
    ],
    "Kit-3-Acoustic": [
      "CyCdh_K3ClHat-01.wav",
      "CyCdh_K3ClHat-02.wav",
      "CyCdh_K3ClHat-03.wav",
      "CyCdh_K3ClHat-04.wav",
      "CyCdh_K3Crash-01.wav",
      "CyCdh_K3Crash-02.wav",
      "CyCdh_K3Crash-03.wav",
      "CyCdh_K3Crash-04.wav",
      "CyCdh_K3Crash-05.wav",
      "CyCdh_K3Crash-06.wav",
      "CyCdh_K3Crash-07.wav",
      "CyCdh_K3HfHat.wav",
      "CyCdh_K3Kick-01.wav",
      "CyCdh_K3Kick-02.wav",
      "CyCdh_K3Kick-03.wav",
      "CyCdh_K3OpHat-01.wav",
      "CyCdh_K3OpHat-02.wav",
      "CyCdh_K3OpHat-03.wav",
      "CyCdh_K3Rim-01.wav",
      "CyCdh_K3SdSt-01.wav",
      "CyCdh_K3SdSt-02.wav",
      "CyCdh_K3SdSt-03.wav",
      "CyCdh_K3SdSt-04.wav",
      "CyCdh_K3SdSt-05.wav",
      "CyCdh_K3SdSt-06.wav",
      "CyCdh_K3SdSt-07.wav",
      "CyCdh_K3Snr-01.wav",
      "CyCdh_K3Snr-02.wav",
      "CyCdh_K3Snr-03.wav",
      "CyCdh_K3Snr-04.wav",
      "CyCdh_K3Snr-05.wav",
      "CyCdh_K3Snr-06.wav",
      "CyCdh_K3Snr-07.wav",
      "CyCdh_K3Snr-08.wav",
      "CyCdh_K3Snr-09.wav",
      "CyCdh_K3Snr-10.wav",
      "CyCdh_K3Tom-01.wav",
      "CyCdh_K3Tom-04.wav",
      "CyCdh_K3Tom-05.wav"
    ],
    "Kit-4-Electro": [
      "CYCdh_ElecK01-ClHat01.wav",
      "CYCdh_ElecK01-ClHat02.wav",
      "CYCdh_ElecK01-ClHat03.wav",
      "CYCdh_ElecK01-Cymbal.wav",
      "CYCdh_ElecK01-Kick01.wav",
      "CYCdh_ElecK01-Kick02.wav",
      "CYCdh_ElecK01-OpHat01.wav",
      "CYCdh_ElecK01-OpHat02.wav",
      "CYCdh_ElecK01-Snr01.wav",
      "CYCdh_ElecK01-Snr02.wav",
      "CYCdh_ElecK01-Snr03.wav",
      "CYCdh_ElecK01-Tom01.wav",
      "CYCdh_ElecK01-Tom02.wav",
      "CYCdh_ElecK01-Tom03.wav",
      "CYCdh_ElecK01-Tom04.wav"
    ],
    "Kit-5-Electro": [
      "CYCdh_ElecK02-Clap01.wav",
      "CYCdh_ElecK02-Clap02.wav",
      "CYCdh_ElecK02-ClHat01.wav",
      "CYCdh_ElecK02-ClHat02.wav",
      "CYCdh_ElecK02-FX01.wav",
      "CYCdh_ElecK02-FX02.wav",
      "CYCdh_ElecK02-FX03.wav",
      "CYCdh_ElecK02-HfHat.wav",
      "CYCdh_ElecK02-Kick01.wav",
      "CYCdh_ElecK02-Kick02.wav",
      "CYCdh_ElecK02-Snr01.wav",
      "CYCdh_ElecK02-Snr02.wav",
      "CYCdh_ElecK02-Tom01.wav",
      "CYCdh_ElecK02-Tom02.wav",
      "CYCdh_ElecK02-Tom03.wav"
    ],
    "Kit-6-Electro": [
      "CYCdh_ElecK03-Clap01.wav",
      "CYCdh_ElecK03-Clap02.wav",
      "CYCdh_ElecK03-ClHat.wav",
      "CYCdh_ElecK03-Kick01.wav",
      "CYCdh_ElecK03-Kick02.wav",
      "CYCdh_ElecK03-OpHat.wav",
      "CYCdh_ElecK03-PdHat.wav",
      "CYCdh_ElecK03-Snr01.wav",
      "CYCdh_ElecK03-Snr02.wav",
      "CYCdh_ElecK03-Tom01.wav",
      "CYCdh_ElecK03-Tom02.wav",
      "CYCdh_ElecK03-Tom03.wav",
      "CYCdh_ElecK03-Tom04.wav",
      "CYCdh_ElecK03-Tom05.wav"
    ],
    "Kit-7-Electro": [
      "CYCdh_ElecK04-Clap.wav",
      "CYCdh_ElecK04-ClHat01.wav",
      "CYCdh_ElecK04-ClHat02.wav",
      "CYCdh_ElecK04-Cymbal01.wav",
      "CYCdh_ElecK04-Cymbal02.wav",
      "CYCdh_ElecK04-HfHat.wav",
      "CYCdh_ElecK04-Kick01.wav",
      "CYCdh_ElecK04-Kick02.wav",
      "CYCdh_ElecK04-Kick03.wav",
      "CYCdh_ElecK04-Snr01.wav",
      "CYCdh_ElecK04-Snr02.wav",
      "CYCdh_ElecK04-Snr03.wav",
      "CYCdh_ElecK04-Tom01.wav",
      "CYCdh_ElecK04-Tom02.wav",
      "CYCdh_ElecK04-Tom03.wav",
      "CYCdh_ElecK04-Tom04.wav"
    ],
    "Kit-8-Vinyl": [
      "CYCdh_VinylK1-ClHat01.wav",
      "CYCdh_VinylK1-ClHat02.wav",
      "CYCdh_VinylK1-Kick01.wav",
      "CYCdh_VinylK1-Kick02.wav",
      "CYCdh_VinylK1-Kick03.wav",
      "CYCdh_VinylK1-OpHat.wav",
      "CYCdh_VinylK1-Shkr01.wav",
      "CYCdh_VinylK1-Shkr02.wav",
      "CYCdh_VinylK1-Shkr03.wav",
      "CYCdh_VinylK1-Snr01.wav",
      "CYCdh_VinylK1-Snr02.wav",
      "CYCdh_VinylK1-Tamb.wav"
    ],
    "Kit-9-Vinyl": [
      "CYCdh_VinylK2-ClHat.wav",
      "CYCdh_VinylK2-HfHat.wav",
      "CYCdh_VinylK2-Kick02.wav",
      "CYCdh_VinylK2-Kicki01.wav",
      "CYCdh_VinylK2-OpHat01.wav",
      "CYCdh_VinylK2-OpHat02.wav",
      "CYCdh_VinylK2-Ride01.wav",
      "CYCdh_VinylK2-Ride02.wav",
      "CYCdh_VinylK2-Snr01.wav",
      "CYCdh_VinylK2-Snr02.wav",
      "CYCdh_VinylK2-Tom01.wav",
      "CYCdh_VinylK2-Tom02.wav"
    ],
    "Kurzweil-Kit-01": [
      "CYCdh_Kurz01-ClHat.wav",
      "CYCdh_Kurz01-Crash01.wav",
      "CYCdh_Kurz01-Crash02.wav",
      "CYCdh_Kurz01-Crash03.wav",
      "CYCdh_Kurz01-Crash04.wav",
      "CYCdh_Kurz01-HfHat.wav",
      "CYCdh_Kurz01-Kick01.wav",
      "CYCdh_Kurz01-Kick02.wav",
      "CYCdh_Kurz01-Kick03.wav",
      "CYCdh_Kurz01-OpHat01.wav",
      "CYCdh_Kurz01-OpHat02.wav",
      "CYCdh_Kurz01-PdHat.wav",
      "CYCdh_Kurz01-RevCrash.wav",
      "CYCdh_Kurz01-Ride01.wav",
      "CYCdh_Kurz01-Ride02.wav",
      "CYCdh_Kurz01-SdSt.wav",
      "CYCdh_Kurz01-Snr01.wav",
      "CYCdh_Kurz01-Snr02.wav",
      "CYCdh_Kurz01-Snr03.wav",
      "CYCdh_Kurz01-Tom01.wav",
      "CYCdh_Kurz01-Tom02.wav",
      "CYCdh_Kurz01-Tom03.wav",
      "CYCdh_Kurz01-Tom04.wav"
    ],
    "Kurzweil-Kit-02": [
      "CYCdh_Kurz02-ClHat.wav",
      "CYCdh_Kurz02-Crash01.wav",
      "CYCdh_Kurz02-Crash02.wav",
      "CYCdh_Kurz02-HfHat.wav",
      "CYCdh_Kurz02-Kick01.wav",
      "CYCdh_Kurz02-Kick02.wav",
      "CYCdh_Kurz02-OpHat.wav",
      "CYCdh_Kurz02-PdHat.wav",
      "CYCdh_Kurz02-Ride01.wav",
      "CYCdh_Kurz02-Ride02.wav",
      "CYCdh_Kurz02-SdSt.wav",
      "CYCdh_Kurz02-Snr01.wav",
      "CYCdh_Kurz02-Snr02.wav",
      "CYCdh_Kurz02-Tom01.wav",
      "CYCdh_Kurz02-Tom02.wav",
      "CYCdh_Kurz02-Tom03.wav",
      "CYCdh_Kurz02-Tom04.wav"
    ],
    "Kurzweil-Kit-03": [
      "CYCdh_Kurz03-ClHat01.wav",
      "CYCdh_Kurz03-ClHat02.wav",
      "CYCdh_Kurz03-Crash01.wav",
      "CYCdh_Kurz03-Crash02.wav",
      "CYCdh_Kurz03-Crash03.wav",
      "CYCdh_Kurz03-HfHat.wav",
      "CYCdh_Kurz03-Kick.wav",
      "CYCdh_Kurz03-OpHat.wav",
      "CYCdh_Kurz03-PdHat.wav",
      "CYCdh_Kurz03-Ride.wav",
      "CYCdh_Kurz03-SdSt.wav",
      "CYCdh_Kurz03-Snr01.wav",
      "CYCdh_Kurz03-Snr02.wav",
      "CYCdh_Kurz03-Tom01.wav",
      "CYCdh_Kurz03-Tom02.wav",
      "CYCdh_Kurz03-Tom03.wav",
      "CYCdh_Kurz03-Tom04.wav"
    ],
    "Kurzweil-Kit-04": [
      "CYCdh_Kurz04-ClHat.wav",
      "CYCdh_Kurz04-Crash01.wav",
      "CYCdh_Kurz04-Crash02.wav",
      "CYCdh_Kurz04-HfHat.wav",
      "CYCdh_Kurz04-Kick01.wav",
      "CYCdh_Kurz04-Kick02.wav",
      "CYCdh_Kurz04-OpHat.wav",
      "CYCdh_Kurz04-PdHat.wav",
      "CYCdh_Kurz04-Ride01.wav",
      "CYCdh_Kurz04-Ride02.wav",
      "CYCdh_Kurz04-SdSt.wav",
      "CYCdh_Kurz04-Snr01.wav",
      "CYCdh_Kurz04-Snr02.wav",
      "CYCdh_Kurz04-Snr03.wav",
      "CYCdh_Kurz04-Snr04.wav",
      "CYCdh_Kurz04-Tom01.wav",
      "CYCdh_Kurz04-Tom02.wav",
      "CYCdh_Kurz04-Tom03.wav",
      "CYCdh_Kurz04-Tom04.wav",
      "CYCdh_Kurz04-Tom05.wav",
      "CYCdh_Kurz04-Tom06.wav"
    ],
    "Kurzweil-Kit-05": [
      "CYCdh_Kurz05-Brsh01.wav",
      "CYCdh_Kurz05-Brsh02.wav",
      "CYCdh_Kurz05-Brsh03.wav",
      "CYCdh_Kurz05-ClHat.wav",
      "CYCdh_Kurz05-Crash01.wav",
      "CYCdh_Kurz05-Crash02.wav",
      "CYCdh_Kurz05-HfHat.wav",
      "CYCdh_Kurz05-Kick01.wav",
      "CYCdh_Kurz05-Kicki02.wav",
      "CYCdh_Kurz05-OpHat.wav",
      "CYCdh_Kurz05-PdHat.wav",
      "CYCdh_Kurz05-Ride01.wav",
      "CYCdh_Kurz05-Ride02.wav",
      "CYCdh_Kurz05-SdSt.wav",
      "CYCdh_Kurz05-Snr.wav",
      "CYCdh_Kurz05-Tom01.wav",
      "CYCdh_Kurz05-Tom02.wav",
      "CYCdh_Kurz05-Tom03.wav",
      "CYCdh_Kurz05-Tom04.wav"
    ],
    "Kurzweil-Kit-06": [
      "CYCdh_Kurz06-ClHat.wav",
      "CYCdh_Kurz06-Crash01.wav",
      "CYCdh_Kurz06-Crash02.wav",
      "CYCdh_Kurz06-HfHat01.wav",
      "CYCdh_Kurz06-HfHat02.wav",
      "CYCdh_Kurz06-Kick01.wav",
      "CYCdh_Kurz06-Kick02.wav",
      "CYCdh_Kurz06-OpHat.wav",
      "CYCdh_Kurz06-PdHat.wav",
      "CYCdh_Kurz06-Ride01.wav",
      "CYCdh_Kurz06-Ride02.wav",
      "CYCdh_Kurz06-SdSt.wav",
      "CYCdh_Kurz06-Snr01.wav",
      "CYCdh_Kurz06-Snr02.wav",
      "CYCdh_Kurz06-Snr03.wav",
      "CYCdh_Kurz06-Tom01.wav",
      "CYCdh_Kurz06-Tom02.wav",
      "CYCdh_Kurz06-Tom03.wav",
      "CYCdh_Kurz06-Tom04.wav"
    ],
    "Kurzweil-Kit-07": [
      "CYCdh_Kurz07-ClHat01.wav",
      "CYCdh_Kurz07-ClHat02.wav",
      "CYCdh_Kurz07-Crash01.wav",
      "CYCdh_Kurz07-Crash02.wav",
      "CYCdh_Kurz07-HfHat01.wav",
      "CYCdh_Kurz07-HfHat02.wav",
      "CYCdh_Kurz07-Kick02.wav",
      "CYCdh_Kurz07-Kick03.wav",
      "CYCdh_Kurz07-Kicki01.wav",
      "CYCdh_Kurz07-OpHat01.wav",
      "CYCdh_Kurz07-OpHat02.wav",
      "CYCdh_Kurz07-Perc01.wav",
      "CYCdh_Kurz07-Perc03.wav",
      "CYCdh_Kurz07-RevCrash01.wav",
      "CYCdh_Kurz07-RevCrash02.wav",
      "CYCdh_Kurz07-RevHat.wav",
      "CYCdh_Kurz07-SdSt.wav",
      "CYCdh_Kurz07-Snr01.wav",
      "CYCdh_Kurz07-Snr02.wav",
      "CYCdh_Kurz07-Snr03.wav",
      "CYCdh_Kurz07-Snr04.wav",
      "CYCdh_Kurz07-Tom01.wav",
      "CYCdh_Kurz07-Tom02.wav",
      "CYCdh_Kurz07-Tom03.wav",
      "CYCdh_Kurz07-Tom04.wav",
      "CYCdh_Kurz07-Tom05.wav"
    ],
    "Kurzweil-Kit-08": [
      "CYCdh_Kurz08-Clap.wav",
      "CYCdh_Kurz08-ClHat.wav",
      "CYCdh_Kurz08-Crash01.wav",
      "CYCdh_Kurz08-Crash02.wav",
      "CYCdh_Kurz08-Crash03.wav",
      "CYCdh_Kurz08-Kick01.wav",
      "CYCdh_Kurz08-Kick02.wav",
      "CYCdh_Kurz08-OpHat.wav",
      "CYCdh_Kurz08-PdHat.wav",
      "CYCdh_Kurz08-Perc01.wav",
      "CYCdh_Kurz08-Perc02.wav",
      "CYCdh_Kurz08-Perc03.wav",
      "CYCdh_Kurz08-Perc04.wav",
      "CYCdh_Kurz08-Perc05.wav",
      "CYCdh_Kurz08-Perc06.wav",
      "CYCdh_Kurz08-Perc07.wav",
      "CYCdh_Kurz08-Perc08.wav",
      "CYCdh_Kurz08-Perc09.wav",
      "CYCdh_Kurz08-Scratch01.wav",
      "CYCdh_Kurz08-Scratch02.wav",
      "CYCdh_Kurz08-Scratch03.wav",
      "CYCdh_Kurz08-SdSt01.wav",
      "CYCdh_Kurz08-SdSt02.wav",
      "CYCdh_Kurz08-Snr01.wav",
      "CYCdh_Kurz08-Snr02.wav",
      "CYCdh_Kurz08-Tom01.wav",
      "CYCdh_Kurz08-Tom02.wav",
      "CYCdh_Kurz08-Tom03.wav",
      "CYCdh_Kurz08-Tom04.wav"
    ]
  }
};
